export const flagUrls: Record<string, string> = {
  fr: 'https://flagcdn.com/w40/fr.png',
  en: 'https://flagcdn.com/w40/gb.png',
  de: 'https://flagcdn.com/w40/de.png',
  es: 'https://flagcdn.com/w40/es.png',
  it: 'https://flagcdn.com/w40/it.png',
  pt: 'https://flagcdn.com/w40/pt.png',
  nl: 'https://flagcdn.com/w40/nl.png',
  pl: 'https://flagcdn.com/w40/pl.png',
  ru: 'https://flagcdn.com/w40/ru.png'
} 